import { Color, FontSize, Spacing } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

import { headerPdfStyles } from '@features/exports/utils/headerPdfStyles'

export const AuditTrailColumnStyles = StyleSheet.create({
  wrapper: {
    width: '100%',
    marginTop: Spacing.S24,
  },
  auditTrailTitle: {
    ...headerPdfStyles.titleText,
    fontSize: FontSize.TextBodySM,
    paddingHorizontal: Spacing.S4,
    paddingVertical: Spacing.S2,
  },
  section: {
    marginBottom: Spacing.S16,
  },
  sectionTitle: {
    fontSize: '10px',
    color: Color.Grey500,
    paddingHorizontal: Spacing.S4,
    marginBottom: Spacing.S4,
  },
  bodyText: {
    fontSize: '10px',
    color: Color.Black,
    wordBreak: 'break-word',
  },
  cellTransaction: {
    width: 20,
  },
  cellDate: {
    width: 55,
  },
  cellVoucher: {
    width: 40,
  },
  cellDescription: {
    minWidth: 80,
    flexGrow: 2,
  },
})
